import React from "react";
import { FaBuilding, FaUsers, FaSuitcase, FaUserPlus } from "react-icons/fa";

const HeroSection = () => {
  const details = [
    {
      id: 1,
      title: "1,23,441",
      subTitle: "Live Job",
      icon: <FaSuitcase />,
    },
    {
      id: 2,
      title: "91220",
      subTitle: "Companies",
      icon: <FaBuilding />,
    },
    {
      id: 3,
      title: "2,34,200",
      subTitle: "Job Seekers",
      icon: <FaUsers />,
    },
    {
      id: 4,
      title: "1,03,761",
      subTitle: "Employers",
      icon: <FaUserPlus />,
    },
  ];
  return (
    <>
      <div className="heroSection">
        <div className="container">
          <div className="title">
            <h1>Find a job that suits</h1>
            <p>
              The Apply Seeker  Website will serve as a vital tool for
              both employers and job seekers, enhancing the recruitment process
              through innovative features and a user-centric approach. By
              leveraging cutting-edge technology and maintaining a focus on
              usability, the platform will bridge the gap between job
              opportunities and qualified candidates, fostering a dynamic and
              efficient employment ecosystem.
            </p>
          </div>
          <div className="image rounded-md border-1">
            <img src="/HomeJobs.jpg" alt="jobs" />
          </div>
        </div>
        <div className="details">
          {details.map((element) => {
            return (
              <div className="card" key={element.id}>
                <div className="icon">{element.icon}</div>
                <div className="content">
                  <p>{element.title}</p>
                  <p>{element.subTitle}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default HeroSection;
